module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_replacer.js
 ** module id = 2507
 ** module chunks = 3
 **/